import { forwardRef } from 'react';
import { styled } from 'goober';

import { EllipsisTextTooltip } from '@/ui/table/infinite-table/ellipsis-text-tooltip';
import { StatusTag } from '@/ui/tag/status-tag';

type ListStatusTagProps = {
  text: string;
  maxWidth?: string;
  isVisible?: boolean;
};

export const ListStatusTag = ({ text, isVisible }: ListStatusTagProps) => {
  return (
    <StatusTag variant="purple" isVisible={isVisible}>
      <EllipsisTextTooltip Component={<EllipsisText />} text={text} />
    </StatusTag>
  );
};

const EllipsisText = styled('p', forwardRef)`
  ${({ theme }) => theme.mixins.ellipsis}
  max-width: 180px;
`;
